import script from "./ShoppingCart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShoppingCart.vue?vue&type=script&lang=ts&setup=true"

import "./ShoppingCart.vue?vue&type=style&index=0&id=115f100a&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115f100a"]])

export default __exports__